import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { updateCacheByType } from "../../../graphql/GraphQlProvider";
import { Resource } from "../../../graphql/resources.datatypes";
import { gqlResource } from "../getResource.api";

interface CloneResourceVars {
    id: number;
    deepClone: boolean;
}

interface CloneResourceData {
    cloneResource: Resource;
}

export const CLONE_RESOURCE_MUTATION = gql`
    mutation cloneResource($id: Int!, $deepClone: Boolean!) {
        cloneResource(id: $id, deepClone: $deepClone) {
          ${gqlResource}
        }
    }
`;

export const cloneResource = () =>
    useMutation<CloneResourceData, CloneResourceVars>(CLONE_RESOURCE_MUTATION, {
        update: updateCacheByType("Resource")
    });

export default cloneResource;
